import React from 'react';
import { Card, CardBody, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Btn, P, H5 } from '../../../../AbstractElements';
import { Close, Modalcontent, NewMessage, SendMessage, StaticExample } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';

const StaticModal = () => {
  return (
    <Col sm='12'>
      <Card>
        <HeaderCard title={StaticExample} />
        <CardBody>
          <div className='modal-dialog modal-lg static-modal mt-0 mb-0'>
            <div className='modal-dialog mt-0 mb-0'>
              <div className='modal-content'>
                <ModalHeader>
                  <div>
                    <H5>{NewMessage}</H5>
                  </div>
                </ModalHeader>
                <ModalBody>
                  <P>{Modalcontent}</P>
                </ModalBody>
                <ModalFooter className='mt-2'>
                  <Btn color='secondary' className='me-2'>
                    {Close}
                  </Btn>
                  <Btn color='primary'>{SendMessage}</Btn>
                </ModalFooter>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StaticModal;
